export const MANUALLY_CHECKED_IN = 'MANUALLY_CHECKED_IN';
export const CHECKED_OUT = 'CHECKED_OUT';
export const SCANNED_IN = 'SCANNED_IN';
export const SCANNED_OUT = 'SCANNED_OUT';

export const isCheckedIn = (state) => [MANUALLY_CHECKED_IN, SCANNED_IN].includes(state);
export const isCheckedOut = (state) => [CHECKED_OUT, SCANNED_OUT].includes(state);
